import React from "react";
import { Route, useParams } from "react-router-dom";

import { AccountGate, AccountGateProvider } from "../../components/AccountGate";
import { AccountHeader } from "../../components/AccountHeader";
import {
  AccountNumberCrumb,
  CustomerNameCrumb,
} from "../../components/Breadcrumb";
import { ModalRoutes } from "../ModalRoutes";
import { NestedRoutes } from "../NestedRoutes";
import { PageComponent } from "../routes";

export const AccountsPage: PageComponent = ({ routes, modals }) => {
  const { accountNumber } = useParams();

  return (
    <AccountGateProvider accountNumber={accountNumber}>
      <AccountGate>
        <AccountHeader />
        {/* Breadcrumbs */}
        <Route path="/accounts/:accountNumber" component={CustomerNameCrumb} />
        <Route
          path="/accounts/:accountNumber/:subpage*"
          component={AccountNumberCrumb}
        />

        {/* Account Modals */}
        <ModalRoutes modals={modals} />

        {/* Account Pages */}
        <NestedRoutes routes={routes} />
      </AccountGate>
    </AccountGateProvider>
  );
};
